import { Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { IndicadoresPainelWrapper } from './indicadores-painel/IndicadoresPainel'

const IndicadoresPage = () => {
  const { t } = useT()

  return (
    <Routes>
      <Route
        path=''
        element={
          <>
            <PageTitle>{t('indicadores.titulo')}</PageTitle>
            <IndicadoresPainelWrapper />
          </>
        }
      />
    </Routes>
  )
}

export default IndicadoresPage
